/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { apiKeysGetTenantDetails } from "../../funcs/apiKeysGetTenantDetails.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdRequest$inboundSchema,
};

export const tool$apiKeysGetTenantDetails: ToolDefinition<typeof args> = {
  name: "api-keys_get-tenant-details",
  description: `Get tenant API key details

Retrieves details of a specific tenant API key`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await apiKeysGetTenantDetails(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
